import { render, staticRenderFns } from "./projectStatistics.vue?vue&type=template&id=ade6abd8&scoped=true&"
import script from "./projectStatistics.vue?vue&type=script&lang=js&"
export * from "./projectStatistics.vue?vue&type=script&lang=js&"
import style0 from "./projectStatistics.vue?vue&type=style&index=0&id=ade6abd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade6abd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ade6abd8')) {
      api.createRecord('ade6abd8', component.options)
    } else {
      api.reload('ade6abd8', component.options)
    }
    module.hot.accept("./projectStatistics.vue?vue&type=template&id=ade6abd8&scoped=true&", function () {
      api.rerender('ade6abd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/projectStatistics.vue"
export default component.exports